import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import ExternalArticleDetailModal from '@/components/container/modal/externalArticle/ExternalArticleDetailModal'

interface ExternalArticleDetailModalState {
  siteId: number
  articlePk: number
}

const defaultValue: ExternalArticleDetailModalState = { siteId: 0, articlePk: 0 }

export const ExternalArticleDetailModalContext =
  createModalContext<ExternalArticleDetailModalState>(defaultValue)

const ExternalArticleDetailModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<ExternalArticleDetailModalState>(defaultValue)
  return (
    <ExternalArticleDetailModalContext.Provider value={state}>
      {children}
      <ExternalArticleDetailModal />
    </ExternalArticleDetailModalContext.Provider>
  )
}

export default ExternalArticleDetailModalProvider
